<app-header
  [sidenav]="false"
  [notificationEnable]="false"
  (loggedOut)="logout()"
></app-header>
<main id="matp-main" class="tw-px-10 tw-overflow-auto matp-main-container">
  <router-outlet />
</main>
